import gql from "graphql-tag";

export default gql`
  mutation DeleteTemplate($templateId: uuid!) {
    deleteTemplate: delete_templates(where: { id: { _eq: $templateId } }) {
      affected_rows
    }
  }
`;
